<template>
    <figure @click="onClick(role)" class="role-button" :data-role="role">
        <img class="role-button__icon" :src="src"/>
        <figcaption class="role-button__name">{{role}}</figcaption>
    </figure>
</template>

<script>

  export default {
    props: {
      role: {
        type: String
      },
      src: {
        type: String
      },
      onClick: {
        type: Function
      },
    }
  }

</script>

<style scoped lang="scss">

    @import '../../common/variables';
    $size: 200px;

    .role-button {
        position: relative;
        display: inline-block;
        width: $size;
        cursor: pointer;
    }

    img {
        display: inline-block;
        height: $size;
        width: $size;
        object-fit: contain;
    }

    figcaption {
        margin-top: 10px;
        font-weight: 600;
    }

</style>
